module.exports = __webpack_public_path__ + "img/gc_black.63c66e37.svg";